import {Component, inject} from '@angular/core';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxTemplateDirective,
    DxFormComponent,
} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent, DxiItemComponent, DxoColumnChooserComponent, DxoExportComponent, DxoFilterRowComponent,
    DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent,
    DxoPagingComponent, DxoPositionComponent, DxoScrollingComponent, DxoSearchComponent, DxoSelectionComponent, DxoSortingComponent,
    DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {
    ShiftType,
    ShiftGridViewDto,
    DayOfWeek
} from "@services";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import EnumUtils from "../../../shared/enum-utils";
import {UserAvatarEmailComponent} from "../../../components/utils/user-avatar-email/user-avatar-email.component";
import {DatePipe} from "@angular/common";
import {ToDatePipe} from "../../../pipes/to-date.pipe";
import {AddShiftFormComponent} from "./add-shift-form/add-shift-form.component";
import {EditShiftFormComponent} from "./edit-shift-form/edit-shift-form.component";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {FilterConfig, GridPageComponent} from "../../common/grid-page.component";
import { DayOfWeekPipe } from 'src/app/pipes/day-of-week.pipe';

@Component({
    selector: 'app-shifts',
    imports: [
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxTemplateDirective,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        UserAvatarEmailComponent,
        DatePipe,
        ToDatePipe,
        DxFormComponent,
        FilterPanelComponent,
        AddShiftFormComponent,
        EditShiftFormComponent,
        DxiButtonComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent
    ],
    providers: [DayOfWeekPipe],
    templateUrl: './shifts.component.html',
    styleUrl: './shifts.component.scss',
})
export class ShiftsComponent extends GridPageComponent<ShiftGridViewDto> {
    protected override exportName: string = "Shifts";
    private dayOfWeekPipe = inject(DayOfWeekPipe);

    constructor() {
        super();
        this.init(ShiftGridViewDto);
    }

    isAddShiftPopupOpened = false;
    isEditShiftPopupOpened = false;
    shiftId: string;
    dataSource = this.dataSources.shifts()
    shiftTypeOptions = EnumUtils.getEnumOptions(ShiftType);

    override nameOrEmailFilter = (filterValue: any, selectedFilterOperation: string) => {
        if (!filterValue) {
            return null;
        }

        return [
            ['supervisor.name', selectedFilterOperation || 'contains', filterValue],
            'or',
            ['supervisor.email', selectedFilterOperation || 'contains', filterValue]
        ];
    };

    protected override filterConfig: FilterConfig[] = [
        {field: 'shiftType', op: '='},
        {field: 'code', op: 'contains'},
        {field: 'supervisor', op: 'contains', gridField: 'supervisor.name', customFilter: this.nameOrEmailFilter},
    ];

    addShift() {
        this.isAddShiftPopupOpened = true;
    };

    override onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const {data} = e;

        this.shiftId = data.id;
        this.isEditShiftPopupOpened = true;
    }

    protected formatDays(days: DayOfWeek[]) {
        return days.map(day => this.dayOfWeekPipe.transform(day)).join(', ');
    }

    protected async onSave() {
        await this.dataGrid.instance.refresh();
    }

    protected onDelete = ($event: any) => {
        this.dataGrid.instance.deleteRow($event.row.dataIndex);
    }

    override onEdit = (e: any) => {
        this.shiftId = e.row.data.id;
        this.isEditShiftPopupOpened = true;
    }
}
